import { Readable } from 'stream';

export interface IAssetInput {
    file: Promise<{
        filename: string;
        mimetype: string;
        encoding: string;
        createReadStream: () => Readable;
    }>;
    timestamp: string;
    comment?: string;
}
